var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feedback-head"},[_c('p',{staticClass:"nav"},[_c('span',{staticClass:"to-left",on:{"click":_vm.goBack}},[_c('icon',{attrs:{"name":"to-left"}})],1),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31665925","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/feedback/feedback-header.vue
// module id = null
// module chunks = 